<template>
  <div class="customer-payments">
    <div class="payments">
      <customer-payment-item
        :style="index !== payments.length - 1 ? 'opacity: 0.5' : ''"
        v-for="(payment, index) in payments"
        :payment="payment"
        :key="payment.id"
      />
    </div>
    <div @click="addingNewPayment = !addingNewPayment" class="add-payment">
      Dodaj odpłatność
    </div>

    <add-payment
      :customerId="customerId"
      v-if="addingNewPayment"
      @paymentAdded="paymentAdded"
    />
  </div>
</template>

<script>
import AddPayment from "./AddPayment.vue";
import CustomerPaymentItem from "./CustomerPaymentItem.vue";
export default {
  components: { CustomerPaymentItem, AddPayment },
  name: "CustomerPayments",
  props: ["customerId"],
  data() {
    return {
      addingNewPayment: false,
    };
  },

  methods: {
    async paymentAdded() {
      this.addingNewPayment = false;
      this.$notify({
        group: "success",
        text: "Odpłatność została dodana",
      });

      await this.$store.dispatch("getCustomerPayments", {
        customerId: this.customerId,
      });
      await this.$store.dispatch("getCustomerMessages", {
        customerId: this.customerId,
      });
      await this.$store.dispatch("getCustomerDetails", {
        customerId: this.customerId,
      });
    },
  },
  computed: {
    payments() {
      return this.$store.getters.getDodSelectedCustomerPayments?.data;
    },
  },
};
</script>

<style scoped>
.customer-payments {
  padding: 1rem;
  width: fit-content;
}
.payments {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
}
.add-payment {
  border-radius: 5px;
  border: 1px solid #090741;
  width: 200px;
  height: 35px;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: center;
  cursor: pointer;
  margin: 1rem 0;
  color: #090741;
}
.add-payment:hover {
  background: rgba(9, 7, 65, 0.25);
}
</style>